"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var grey = {
  50: '#f5f5f5',
  100: '#dbdbdb',
  200: '#c2c2c2',
  300: '#a8a8a8',
  400: '#8f8f8f',
  500: '#757575',
  600: '#5c5c5c',
  700: '#424242',
  800: '#292929',
  900: '#101010',
  A100: '#c4c9cc',
  A200: '#abb0b3',
  A400: '#7b8083',
  A700: '#33383b'
};
exports["default"] = grey;